import React from 'react'

import { isAskMdtAvailable, type AiRuntimeConfig } from './availability'
import { AskMdtCommandDialog } from './components/AskMdtCommandDialog'
import { AskMdtSheet } from './components/AskMdtSheet'
import { AskMdtProvider } from './context/AskMdtProvider'
import { DailyBriefingProvider } from 'features/Home/context/DailyBriefingProvider'

/**
 * Ask MDT, mounted only where it is offered (MYD-621): AI switched on for
 * this deployment and allowed for this account (availability.ts). Elsewhere
 * nothing is mounted, so the header button and Cmd/Ctrl+K do not exist.
 *
 * Mounted once, in App.tsx, around the signed-in layout.
 *
 * The Daily Briefing popup is mounted here too (MYD-645): it is offered on
 * the same terms, and here, above the routes, it survives a page change.
 */
export function AskMdtRoot({ user, config, children }: { user: any; config?: AiRuntimeConfig; children: React.ReactNode }) {
	if (!isAskMdtAvailable(user, config)) return <>{children}</>
	return (
		<AskMdtProvider>
			<DailyBriefingProvider>
				{children}
				<AskMdtCommandDialog />
				<AskMdtSheet />
			</DailyBriefingProvider>
		</AskMdtProvider>
	)
}

export default AskMdtRoot
